module.exports = __webpack_public_path__ + "assets/img/certi.1cc5aaa9.jpg";